import { call, put, takeLatest } from "redux-saga/effects";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eMucTriNangActionIds,
  IMucTriNangActionTypes,
} from "../../action-types/category/IMucTriNangActions";
import { rootActions } from "../../actions/rootActions";
import { mucTriNangApi } from "../../../api/category/mucTriNangApi";
import { IMucTriNang } from "../../../model/respone/category/IMucTriNang";

export function* mucTriNangSaga(): any {
  yield takeLatest(eMucTriNangActionIds.LOAD_START, loadWorker);
  yield takeLatest(eMucTriNangActionIds.DELETE_START, deleteWorker);
  yield takeLatest(eMucTriNangActionIds.SAVE_START, saveWorker);
}

function* loadWorker(): any {
  const res: IBaseRespone = yield call(mucTriNangApi.SelectAll);
  if (res.is_success) {
    yield put(rootActions.category.mucTriNang.LOAD_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.category.mucTriNang.LOAD_ERRR(res.message ?? "Có lỗi")
    );
  }
}
function* saveWorker(action: IMucTriNangActionTypes): any {
  let res: IBaseRespone;
  const payload = action.payload as IMucTriNang;
  if (payload.id > 0) {
    res = yield call(mucTriNangApi.Update, payload);
  } else {
    res = yield call(mucTriNangApi.Insert, payload);
  }
  if (res) {
    if (res.is_success) {
      yield put(rootActions.category.mucTriNang.SAVE_SUCCESS(res.data));
    } else {
      yield put(
        rootActions.category.mucTriNang.SAVE_ERROR(res.message ?? "Có lỗi")
      );
    }
  }
}

function* deleteWorker(action: IMucTriNangActionTypes): any {
  const res: IBaseRespone = yield call(
    mucTriNangApi.Delete,
    action.payload as number
  );
  if (res.is_success) {
    yield put(rootActions.category.mucTriNang.DELETE_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.category.mucTriNang.DELETE_ERROR(res.message ?? "Có lỗi")
    );
  }
}
